import React from 'react';
import { useTranslation } from 'react-i18next';
import { Badge, Button } from '@components';
import { FaqEntry } from '../types';

interface FaqEntryStatusProps {
  entry: FaqEntry;
  onRetry: () => void;
  isRetrying: boolean;
}

// Shows only while the entry is processing or after it failed
export const FaqEntryStatus: React.FC<FaqEntryStatusProps> = ({ entry, onRetry, isRetrying }) => {
  const { t } = useTranslation();

  if (entry.status === 'processing') {
    return (
      <>
        <Badge variant="info" size="sm">
          {t('knowledgeBase.faq.status.processing')}
        </Badge>
        {/* Restarts an entry stuck after a lost task; harmless while it is still running */}
        <Button
          variant="ghost"
          size="sm"
          onClick={onRetry}
          disabled={isRetrying}
          className="p-1 h-7 w-7"
          title={t('knowledgeBase.faq.reprocess')}
        >
          <span className="material-icons text-base text-gray-600 dark:text-gray-400">refresh</span>
        </Button>
      </>
    );
  }
  if (entry.status === 'failed') {
    return (
      <>
        <Badge variant="error" size="sm">
          {t('knowledgeBase.faq.status.failed')}
        </Badge>
        <span className="text-xs text-gray-600 dark:text-gray-400">
          {entry.is_indexed
            ? t('knowledgeBase.faq.previousVersionActive')
            : t('knowledgeBase.faq.notAvailableForAgent')}
        </span>
        <Button variant="outline" size="sm" onClick={onRetry} disabled={isRetrying} className="h-7">
          {t('knowledgeBase.faq.reprocess')}
        </Button>
      </>
    );
  }
  return null;
};
